export const getBaseUrl = () => {
  let baseUrl = process.env.MZS_API_URL ? process.env.MZS_API_URL.trim() : ''

  if (!baseUrl) {
    return undefined
  }

  if (baseUrl.endsWith('/')) {
    return baseUrl.slice(0, -1)
  }

  return baseUrl
}

